<template>
  <v-container class="mt-8">


    <h2 class="mt-5 pb-1">All Patient Records</h2>
    <!-- <v-alert :show="indexes.errorMessage">{{ indexes.errorMessage }}</v-alert>  -->

    <div class="d-flex mb-5 mt-10">
      <v-text-field
        @keyup.native="search"
        placeholder="Search for indexes..."
        class="flex-fill"
        color="black"
      ></v-text-field>

      <v-btn text dark style="background-color: #d9534f;" class="ml-3 mt-2"  @click="create()">
        Create New
      </v-btn>
    </div>

    <div class="loading" v-if="loading === true">
      <h2>Loading</h2>
      <img src="../../../assets/loading.png" alt="Loading" />
    </div>

    <section class="results" v-else>

      <v-card
        v-for="item in indexes.filtered"
        @click="view(item._id)"
        :key="item._id"
        class="mt-3"
        flat
        outlined
      >
        <v-card-title>{{item.identifier}}</v-card-title>

        <!-- **** Code Below was commented out before Vuetify Changes **** -->

        <!-- <p>
          <b-badge
            pill
            variant="secondary"
            v-for="(category, identifier) in item.categories"
            v-bind:key="category.category_id"
          >
            {{ category.display_name }}
          </b-badge>
        </p> -->
        <!-- <b-button size="sm" variant="success" @click="edit(item._id)">
          Edit
        </b-button>
        <b-button size="sm" variant="danger" @click="delete item._id">
          Delete
        </b-button> -->
      </v-card>
    </section>
  </v-container>
</template>
<script>
import { keys, forEach, isEmpty, clone, filter, join, toLower } from 'lodash';
import { mapGetters } from 'vuex'

export default {
  name: 'Indexes',
  data() {
    return {};
  },
  created() {
    this.query();
  },
  computed: {
    ...mapGetters({
      indexes: 'getIndexes',
      loading: 'getLoadingStatus',
    }),
  },
  methods: {
    edit(id) {
      this.$router.push({ name: 'EditIndex', params: { id: id } });
    },
    /*  We might need this for the real ViewIndex some day.
    view(id) {
      this.$router.push({ name: 'ViewIndex', params: { id: id } });
    },
    */
    create() {
      this.$router.push({ name: 'AddIndex' });
    },
    delete(id) {
      this.$store.dispatch('deleteCollectionId', {collection: 'indexes', id: id})
    },
    query() {
      this.$store.dispatch('loadIndexes')
    },
    search($event) {
      if ($event && $event.target && $event.target.value) {
        this.$store.dispatch('searchIndexes', $event.target.value)
      }
    },
  },
};
</script>
